import { type AssetType } from "@doitintl/cmp-models";

export const getBucketTypeDisplayName = (type: AssetType | null) => {
  if (type === null) {
    return null;
  }

  switch (type) {
    case "amazon-web-services":
      return "AWS";
    case "google-cloud":
    case "google-cloud-project":
      return "Google Cloud";
    case "microsoft-azure":
      return "Azure";
    case "g-suite":
      return "Google Workspace";
    case "office-365":
      return "Office 365";
    default:
      return type;
  }
};

export const mapAssetTypeToBucketType = (assetType: AssetType): AssetType | null => {
  if (assetType === "google-cloud-project") {
    return "google-cloud";
  }

  return assetType;
};

export const getIndefiniteArticle = (word: string) => {
  const lowerWord = word.toLowerCase();
  const startsWithVowelSound = /^[aeiou]/;
  return startsWithVowelSound.test(lowerWord) ? "an" : "a";
};
